module.exports = __webpack_public_path__ + "static/media/medycon-login-background-1.966901a7.jpg";